import { memo } from 'react';
import { Alert, AlertProps, Card, Col, Row, Statistic } from 'antd';
import dayjs from 'dayjs';

import { Auction, isEndedAuction, isNotYetStartedAuction } from 'models/auction/Auction';
import { formatCurrency } from 'utils';

import styles from './AuctionStatistics.module.css';
import BidsListButton from 'pages/bids/BidsList/BidsListButton';

interface AuctionStatisticsProps {
  auction: Auction;
}

function AuctionStatistics({ auction }: AuctionStatisticsProps) {
  const { id, starts_at, ends_at, current_price, bid_count, state } = auction;
  const isCanceledAuction = state === 'canceled';

  const bidsListButton = (
    <>
      {'[ '}
      <BidsListButton auctionId={id} bidCount={bid_count} />
      {' ]'}
    </>
  );

  let message = null;
  let messageType: AlertProps['type'] = undefined;

  let countdownTitle = null;
  let deadline = null;

  let priceDescription = null;

  if (isCanceledAuction) {
    message = '취소된 경매입니다.';
    messageType = 'error';
  } else if (isEndedAuction(auction)) {
    message = '종료된 경매입니다.';
    messageType = 'error';
    priceDescription = <>낙찰가 {bidsListButton}</>;
  } else if (isNotYetStartedAuction(auction)) {
    message = '경매가 아직 시작되지 않았습니다.';
    messageType = 'warning';
    deadline = +starts_at;
    countdownTitle = '경매 시작까지';
    priceDescription = '시작가';
  } else {
    message = '경매가 시작되었습니다!';
    messageType = 'success';
    deadline = +ends_at;
    countdownTitle = '경매 종료까지';
    priceDescription = <>현재 최고가 {bidsListButton}</>;
  }

  return (
    <div>
      <Alert message={message} type={messageType} showIcon />
      {!isCanceledAuction && (
        <Card className={styles.statistics} size="small">
          <Row>
            {deadline && (
              <Col span={16}>
                <Statistic.Countdown
                  title={countdownTitle}
                  value={deadline}
                  format={dayjs.unix(deadline / 1000).diff(dayjs(), 'day') > 0 ? 'D일 H시간 m분 s초' : 'HH:mm:ss'}
                />
              </Col>
            )}
            <Col>
              <Statistic title={priceDescription} value={formatCurrency(current_price)} />
            </Col>
          </Row>
        </Card>
      )}
    </div>
  );
}

export default memo(AuctionStatistics);
